var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHasPrintedLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.9993,
    rx: 4,
    fill: "#087E38",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7594 5.40188C20.0801 5.08118 20.0801 4.56122 19.7594 4.24052C19.4387 3.91983 18.9188 3.91983 18.5981 4.24052L16.8439 5.99471L11.7375 5.11933C11.4762 5.07094 11.2173 5.08788 10.9609 5.17014C10.7044 5.2524 10.4794 5.39031 10.2858 5.58387L4.47906 11.3907C4.15969 11.71 4 12.0972 4 12.552C4 13.0069 4.15969 13.394 4.47906 13.7134L10.2858 19.5202C10.6052 19.8395 10.9923 19.9992 11.4472 19.9992C11.9021 19.9992 12.2892 19.8395 12.6086 19.5202L18.4153 13.7134C18.6089 13.5198 18.7468 13.2948 18.8291 13.0383C18.9113 12.7819 18.9283 12.523 18.8799 12.2617L18.0047 7.15659L19.7594 5.40188ZM15.4197 7.41893L14.0815 8.75714C13.7608 9.07784 13.7608 9.5978 14.0815 9.9185C14.4022 10.2392 14.9221 10.2392 15.2428 9.9185L16.5805 8.58082L17.254 12.552L11.4472 18.3588L8.54381 15.4554L5.64042 12.552L11.4472 6.74523L15.4197 7.41893Z",
    fill: "#087E38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasPrintedLabel);
export default __webpack_public_path__ + "static/media/has-printed-label.9afcdc77cce955dad77e6580e816120a.svg";
export { ForwardRef as ReactComponent };